/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscription_Rights_FreezeInputs */

const fr_admin_subscription_rights_freeze = /** @type {(inputs: Admin_Subscription_Rights_FreezeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernière pause (freeze)`)
};

/**

* @param {Admin_Subscription_Rights_FreezeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_subscription_rights_freeze = /** @type {((inputs?: Admin_Subscription_Rights_FreezeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscription_Rights_FreezeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_subscription_rights_freeze(inputs)
});